import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const leigado: ImportTypeConfig = {
  dateFormat: { default: 'DD/MM/YYYY' },
  instructions: {
    software: 'Leigado',
  },
  type: 'leigado',
}
